export const numberWithCommas = (x: number | string): string => {
  const numStr = typeof x === 'number' ? `${x}` : x;
  return numStr?.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export const addZeroStartStr = (num: number | string, count: number) => {
  const numStr = typeof num === 'number' ? `${num}` : num;
  return numStr.padStart(count, '0');
};

export const addZeroEndStr = (num: number | string, count: number) => {
  const numStr = typeof num === 'number' ? `${num}` : num;
  return numStr.padEnd(count, '0');
};

export const setStrongTag = (str: string, keyword: string) => {
  if (!str || typeof str !== 'string') {
    return str;
  }

  return str?.split(keyword)?.join(`<strong>${keyword}</strong>`);
};

export const getPriceNumToStr = (num: number) => {
  if (num <= 0) return '0';
  let inputNumber = num;
  let unitWords = ['', '만', '억', '조', '경'];
  let splitUnit = 10000;
  let resultArray = [];
  let du = inputNumber.toString().split('.')[1];

  for (let i = 0; i < unitWords.length; i++) {
    let unitResult = (inputNumber % Math.pow(splitUnit, i + 1)) / Math.pow(splitUnit, i);
    unitResult = Math.floor(unitResult);
    if (unitResult > 0) {
      resultArray[i] = unitResult;
    }
  }

  let resultString = resultArray.reduce((acc, cur, idx) => (cur ? numberWithCommas(cur) + unitWords[idx] + ' ' + acc : acc), '');

  return (resultString ? resultString : '0') + (resultString.length < 2 && du ? '.' + du : '');
};

// window scroll top
export const moveScrollTop = () => {
  window.scroll({ top: 0, behavior: 'instant' });
};
